import InvoiceForm from 'app/components/InvoiceForm/InvoiceForm'
import { useNavigate } from 'react-router'
import useUpdateInvoice from './hooks/useUpdateInvoice'
import { InvoiceFormValues } from 'app/components/InvoiceForm/schema'
import { useCallback } from 'react'
import withInvoice from 'hocs/WithInvoice'
import { Invoice } from 'types'
import { Flex } from 'antd'

interface InvoiceEditProps {
  invoice: Invoice
}

const InvoiceEdit = ({ invoice }: InvoiceEditProps) => {
  const navigate = useNavigate()

  const { updateInvoice } = useUpdateInvoice({
    onSuccess: () => {
      navigate(`/`)
    },
  })

  const handleSave = useCallback(
    (data: InvoiceFormValues) => {
      updateInvoice({ invoice, data })
    },
    [updateInvoice, invoice]
  )

  return (
    <Flex vertical gap="1rem">
      <h2>Update an invoice</h2>
      <InvoiceForm invoice={invoice} onSave={handleSave} />
    </Flex>
  )
}

export default withInvoice(InvoiceEdit)
